/**
 * Two Images Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initTwoImages() {
        const blocks = document.querySelectorAll('.two-images');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] two-images block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTwoImages);
    } else {
        initTwoImages();
    }
})();